<template>
  <div>
    <div class="text-right">
      <b-button
        variant="primary"
        size="sm"
        type="submit"
        class="dragCancel"
        @click.prevent="save"
        >Save</b-button
      >
    </div>
    <b-form
      class="widgetEditForm"
      @submit.prevent="save"
      :editWidgetKey="widgetKey"
    >
      <div v-if="widget" class="widgetEditForm__content">
        <b-form-group label="Card title:" label-size="sm">
          <b-form-input
            v-model="title"
            name="editor-title"
            size="sm"
            type="text"
            @keydown.ctrl.83.native.prevent="save"
            class="dragCancel"
          />
        </b-form-group>
        <b-form-group label-size="sm" label="Widget classes:">
          <b-form-input
            size="sm"
            v-model="classes"
            name="editor-classes"
            type="text"
            @keydown.ctrl.83.native.prevent="save"
            class="dragCancel"
          />
        </b-form-group>
        <b-form-group label="Widget Resizing And Scrolling">
          <b-form-radio-group
            id="radio-group-1"
            v-model="overflow"
            :options="[
              { text: 'Auto Expand Height', value: 'height:auto' },
              { text: 'Show Scroll Bars', value: 'overflow:auto' },
              { text: 'Hide Scroll Bars', value: 'overflow:hidden' },
            ]"
            name="radio-options"
          ></b-form-radio-group>
        </b-form-group>

        <b-form-group label-size="sm" label="Layout:">
          <b-form-select
            size="sm"
            v-model="layout"
            name="editor-layout"
            :options="layouts"
            class="dragCancel"
          />
        </b-form-group>

        <div v-if="widget.type === 'card-list'">
          <b-form-group label="Item width type">
            <b-form-radio
              v-model="widget.widthType"
              value="columnCount"
              @change="setInitialColumnCount(widget)"
              >Column count</b-form-radio
            >
            <b-form-radio
              v-model="widget.widthType"
              value="minAndMaxWidth"
              @change="setInitialMinAndMaxWidth(widget)"
              >Min and Max width</b-form-radio
            >
          </b-form-group>

          <b-form-group
            label="Column count"
            v-if="widget.widthType === 'columnCount'"
          >
            <b-form-select
              v-model="widget.columnCount"
              :options="[1, 2, 3, 4, 6, 8, 10, 12]"
              size="sm"
            />
          </b-form-group>

          <b-form-group
            label="Column Min and Max width"
            v-if="widget.widthType === 'minAndMaxWidth'"
          >
            <b-input-group
              size="sm"
              prepend="Min"
              append="px"
              style="margin-bottom: 10px;"
            >
              <b-form-input v-model="widget.columnMinWidth" type="number" />
            </b-input-group>
            <b-input-group size="sm" prepend="Max" append="px">
              <b-form-input v-model="widget.columnMaxWidth" type="number" />
            </b-input-group>
          </b-form-group>

          <b-form-group
            label="Items per page"
            v-if="widget.widthType === 'minAndMaxWidth'"
          >
            <b-form-select
              v-model="widget.itemsPerPage"
              :options="[10, 20, 40, 60]"
              size="sm"
            />
          </b-form-group>
        </div>

        <b-form-group
          id="fwBootstrapEditSideBar"
          v-if="editorElement"
          label-size="sm"
          :label="'Bootstrap options for ' + editorElement.tagName + ':'"
        >
          <b-card
            v-for="tab in frontwiseOptionsMap.tabs"
            v-bind:key="'fwTabKey_' + tab.id"
            class="mt-3 p-0"
            body-class="p-0"
            header-class="text-left p-0"
          >
            <template v-slot:header>
              <div v-b-toggle="'fwTab_' + tab.id" class="fwtabHeading">
                <span class="expand">&#9654;</span>
                <div class="text-center w-100">{{ tab.label }}</div>
              </div>
            </template>

            <b-collapse visible :id="'fwTab_' + tab.id" class="mt-1">
              <div v-for="(opt, idx) in frontwiseOptionsMap.map" :key="idx">
                <options-map-input
                  v-if="opt.tab === tab.id"
                  :opt="opt"
                  :editor-element="editorElement"
                  :update-template="updateTemplate"
                ></options-map-input>
              </div>
            </b-collapse>
          </b-card>
        </b-form-group>

        <b-form-group
          v-if="editorElement"
          class="mt-2"
          label-size="sm"
          label="Element text:"
        >
          <treeselect
            v-if="
              editorElement &&
                !editorElement.classList.contains('row') &&
                !editorElement.classList.contains('column')
            "
            v-model="editorElement.innerHTML"
            :multiple="false"
            :options="dataSourceList"
            :always-open="false"
            :searchable="true"
            :clearable="true"
            :defaultExpandLevel="2"
            :clear-on-select="true"
            :maxHeight="200"
            :flat="false"
          />
        </b-form-group>

        <b-form-group class="mt-2" label-size="sm" label="Template:">
          <codemirror
            :value="templateCode"
            :options="cmTemplateOptions"
            name="editor-templateCode"
            @keydown.ctrl.83.native.prevent="save"
            @input="onCmTemplateCodeChange"
            class="dragCancel"
          />
        </b-form-group>

        <b-form-group>
          <div>
            <h2>
              Editor -
              <span v-if="editorElement">{{ editorElement.tagName }}</span>
            </h2>
            <div>
              <label v-show="elText">Text:</label>
              <b-form-textarea
                v-show="elText"
                id="textarea"
                v-model="elText"
                name="editor-elText"
                placeholder
                rows="3"
                max-rows="6"
                @input="textChange"
              ></b-form-textarea>
              <b-form-radio-group
                id="btn-radios-3"
                v-model="elColClass"
                @change="cellColChange"
                :options="[
                  { text: '1', value: 'col-1' },
                  { text: '2', value: 'col-2' },
                  { text: '4', value: 'col-4' },
                  { text: '6', value: 'col-6' },
                ]"
                buttons
                name="radio-btn-stacked"
              ></b-form-radio-group>
              {{ this.elColClass }}
              <label>Classes:</label>
              <div>
                <treeselect
                  @input="updateEl"
                  v-model="editorClasses"
                  :multiple="true"
                  :options="options"
                  :always-open="false"
                  :searchable="true"
                  :clearable="true"
                  :defaultExpandLevel="2"
                  :flat="true"
                  :maxHeight="150"
                />
              </div>

              <b-button
                hidden
                variant="success"
                size="sm"
                @click="updateComponent"
                >Update Component Settings</b-button
              >

              <b-button
                v-show="editorElement"
                class="m-1 float-right"
                size="sm"
                variant="success"
                @click="copyElement"
                >Copy</b-button
              >

              <b-button
                v-show="editorElement && elToCopy"
                class="m-1 float-right"
                size="sm"
                variant="success"
                @click="pasteElement"
                >Paste</b-button
              >

              <b-button
                v-show="editorElement"
                class="m-1 float-right"
                size="sm"
                variant="warning"
                @click="removeElement"
                >Remove</b-button
              >
            </div>
          </div>
        </b-form-group>

        <b-form-group>
          <label>Styles:</label>
          <codemirror
            :value="stylesCode"
            name="editor-stylesCode"
            :options="cmStylesOptions"
            @keydown.ctrl.83.native.prevent="save"
            @input="onCmStylesCodeChange"
            class="dragCancel"
          />
        </b-form-group>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AutoSuggest from '@/libs/auto-suggest/src/AutoSuggest'
// services
import db from '@/services/db'
// helpers
import constants from '@/helpers/constants'

import eventBus from '@/helpers/event-bus'

/** required by libs/frontwise-editor to style elements */
import FWTools from '@/libs/frontwise-editor/tools.js'
import optionsMap from '@/libs/frontwise-editor/optionsMap.js'
import optionsMapInput from '@/libs/frontwise-editor/optionsMapInput.vue'

import beautifier from '@/libs/frontwise-editor/js-beautify-nolowercase'

const prettyHtml = beautifier.html
const prettyCss = beautifier.css

export default {
  components: {
    optionsMapInput,
  },
  data() {
    return {
      frontwiseLoaded: false,
      frontwiseOptionsMap: optionsMap,
      propsArray: [],
      widgetKey: null,
      widget: null,
      title: null,
      templateCode: null,
      stylesCode: null,
      classes: null,
      layout: null,
      overflow: null,
      layouts: [
        { text: 'B-Card', value: 'b-card' },
        { text: 'Standard', value: null },
      ],
      cmTemplateOptions: constants.cmTemplateOptions,
      cmStylesOptions: constants.cmStylesOptions,
      inProgress: false,
      unwatch: null,
      selectedTemplateType: 'list',
      editorClasses: [],
      editorElement: null,
      addTreeValue: 'Select',
      elText: '',
      elClassOptions: {},
      elColClass: '',
      elToCopy: null,
      addOptions: [
        {
          id: 'Select',
          label: 'Select',
        },
        {
          id: 'grid',
          label: 'Grid',
          children: [
            {
              id: 'row',
              label: 'Row',
            },
            {
              id: 'col',
              label: 'Column',
            },
          ],
        },
        {
          id: 'content',
          label: 'Content',
          children: [
            {
              id: 'button',
              label: 'button',
            },
            {
              id: 'h1',
              label: 'h1',
            },
            {
              id: 'h2',
              label: 'h2',
            },
            {
              id: 'h3',
              label: 'h3',
            },
            {
              id: 'p',
              label: 'p',
            },
          ],
        },
      ],
      options: [
        {
          id: 'layout',
          label: 'Layout',
          children: [
            {
              id: 'p-1',
              label: 'Padding 1',
            },
            {
              id: 'm-1',
              label: 'Margin 1',
            },
            {
              id: 'float-right',
              label: 'Float Right',
            },
            {
              id: 'float-left',
              label: 'Float Left',
            },
          ],
        },
        {
          id: 'gridColumns',
          label: 'Grid Columns',
          children: [
            {
              id: 'row',
              label: 'Row Container',
            },
            {
              id: 'col-2',
              label: '2 Column',
            },
            {
              id: 'col-4',
              label: '4 Column',
            },
            {
              id: 'col-6',
              label: '6 Column',
            },
            {
              id: 'col-8',
              label: '8 Column',
            },
            {
              id: 'col-10',
              label: '10 Column',
            },
          ],
        },
        {
          id: 'button',
          label: 'Button',
          children: [
            {
              id: 'btn',
              label: 'Button',
            },
            {
              id: 'btn-primary',
              label: 'Primary',
            },
            {
              id: 'btn-secondary',
              label: 'Secondary',
            },
            {
              id: 'btn-alert',
              label: 'Alert',
            },
            {
              id: 'btn-warning',
              label: 'Warning',
            },
          ],
        },
      ],
      autoSuggestInstance: null,
    }
  },
  computed: {
    ...mapState([
      'toolsPanel_openedItemsDescription',
      'dataGrid_options',
      'computedProps',
    ]),
    dataSourceList() {
      var list = []
      if (this.dataGrid_options) {
        for (let grid in this.dataGrid_options) {
          const id = `{{ $getGrid('${grid}') }}`
          const label = 'List > ' + this.dataGrid_options[grid].title

          list.push({ id, label })
        }

        for (let grid in this.dataGrid_options) {
          var meta = this.dataGrid_options[grid].meta
          var gridtitle = this.dataGrid_options[grid].title

          Object.keys(meta).forEach(function(key) {
            const id = `{{ $sum('${grid}', '${key}') }}`
            const label = '$ Sum ' + gridtitle + '.' + meta[key].displayName

            list.push({ id, label })
          })

          const id = `{{ $sum('${grid}', '$count') }}`
          const label = '$ Count ' + gridtitle

          list.push({ id, label })
        }
      }
      if (this.computedProps) {
        for (let prop in this.computedProps) {
          const id = '{{ ' + prop + ' }}'
          const label = 'Computed > ' + prop

          list.push({ id, label })
        }
      }
      return list
    },
    dataSourceOptions() {
      const list = []

      let value = ''
      let name = ''

      //date functions
      value = `getDate()`
      name = `CurrentDate`
      list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })

      value = `moment(getDate()).format('l')`
      name = `CurrentDate(Day Format)`
      list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })

      value = `fbUser.email`
      name = `UserEmail`
      list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })

      value = `fbUser.displayName`
      name = `UserName`
      list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })

      value = `fbUser.uid`
      name = `UserID`
      list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })

      if (this.widget.dataSource) {
        for (let field in this.dataGrid_options[this.widget.dataSource].meta) {
          let f = this.dataGrid_options[this.widget.dataSource].meta[field]

          // console.log(f.displayName, f)
          value = `row.${field}`
          name = `row.${field}`
          list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })

          if (f.type == 'date') {
            value = `row.$${field}$MonthYear`
            name = `row.${field}$MonthYear`
            list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })

            value = `row.$${field}$Month`
            name = `row.${field}$Month`
            list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })

            value = `row.$${field}$YearWeek`
            name = `row.${field}$YearWeek`
            list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })

            value = `row.$${field}$Date`
            name = `row.${field}$Date`
            list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })
          }

          if (f.lookUpTable) {
            let lookupFields = this.dataGrid_options[f.lookUpTable].meta
            value = `row.$${field}$display`
            name = `row.${field}$display`

            list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })

            for (let refField in lookupFields) {
              value = `row.$${field}.${refField}`
              name = `row.${field}.${refField}`

              list.push({
                on: [name],
                show: name,
                insertText: `{{ ${value} }}`,
              })
            }
          }
        }
      }

      if (this.dataGrid_options) {
        for (let grid in this.dataGrid_options) {
          value = `$getGrid('${grid}')`
          name = 'List > ' + this.dataGrid_options[grid].title

          list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })
        }

        for (let grid in this.dataGrid_options) {
          var meta = this.dataGrid_options[grid].meta
          var gridtitle = this.dataGrid_options[grid].title

          Object.keys(meta).forEach(function(key) {
            const value = `$sum('${grid}', '${key}')`
            const name = '$ Sum ' + gridtitle + '.' + meta[key].displayName

            list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })
          })

          const value = `$sum('${grid}', '$count')`
          const name = '$ Count ' + gridtitle

          list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })
        }
      }

      if (this.computedProps) {
        for (let prop in this.computedProps) {
          const value = 'Computed > ' + prop
          const name = prop

          list.push({ on: [name], show: name, insertText: `{{ ${value} }}` })
        }
      }

      return list
    },
  },
  methods: {
    updateComponent() {
      var newTemplate = this.updateTemplate()

      this.propsArray.forEach(function(entry, i) {
        newTemplate = newTemplate.replace(entry.oldValue, entry.value)
      })
      this.templateCode = newTemplate
    },
    onCmTemplateCodeChange(code) {
      this.templateCode = code
    },
    onCmStylesCodeChange(code) {
      this.stylesCode = code
    },
    save() {
      this.inProgress = true

      const widget = Object.assign({}, this.widget)
      widget.title = this.title || ''
      widget.template = this.templateCode || ''
      widget.styles = this.stylesCode || ''
      widget.classes = this.classes || ''
      widget.layout = this.layout || ''
      widget.overflow = this.overflow || ''

      this.$store.commit('addProcess', {
        process: 'updateWidget',
        message: 'Updating',
      })

      db.widgets.update(this.widgetKey, widget, err => {
        if (err) this.$store.commit('addError', err.message)
        this.$store.commit('deleteProcess', 'updateWidget')

        this.inProgress = false
      })

      $('.templateWrapper').gridEditor('remove')

      setTimeout(function() {
        $('.templateWrapper').gridEditor({
          new_row_layouts: [[12], [6, 6], [4, 4, 4]],
          content_types: ['summernote'],
          updateTemplate: this.updateTemplate,
          summernote: {
            config: {
              callbacks: {
                onInit: function() {
                  var element = this
                  console.log('init done', element)
                },
              },
            },
          },
        })
      }, 0)
    },
    getWidget() {
      db.getRef('widgets')
        .child(this.widgetKey)
        .once('value', snapshot => {
          const widget = snapshot.val()

          if (widget) {
            this.widget = widget
            this.title = this.widget.title || ''
            this.templateCode =
              prettyHtml(this.widget.template, {
                indent_size: 2,
                space_in_empty_paren: true,
              }) || ''
            this.stylesCode = this.widget.styles || ''
            this.classes = this.widget.classes || ''
            this.layout = this.widget.layout || ''
            this.overflow = this.widget.overflow || ''
          }
        })
    },
    selectElement() {
      this.$nextTick(function() {
        var prevElement = null
        if (!document.querySelector('.templateWrapper')) return

        document
          .querySelector(
            '.templateWrapper:not(.ge-tools-rows):not(.ge-tools-cols):not(.tools)'
          )
          .addEventListener(
            'mousemove',
            function(e) {
              //console.log(e)
              var elem = e.target || e.srcElement
              if ($(elem).hasClass('tools')) return
              if (prevElement != null) {
                prevElement.removeAttribute('mouseOn')
              }
              elem.setAttribute('mouseOn', 'mouseOn')
              prevElement = elem
            },
            true
          )

        $('.templateWrapper *').on({
          mouseleave: function() {
            $(this).removeAttr('mouseOn')
          },
        })

        this.updateTemplate()
      })
    },
    updateEl(value) {
      var cList = value.join(' ')
      //cList.replace('mouseOn', '')
      this.editorElement.setAttribute('class', cList)
    },
    updateTemplate() {
      // This parser turned of cuz it's breaking component call
      return

      $('.templateWrapper *')
        .removeAttr('tagname')
        .removeAttr('editselected')
        .removeAttr('contenteditable')
        .removeAttr('mouseon')
      let templateHTML = null,
        $wrapper = $('.templateWrapper'),
        innerHtml = $wrapper.gridEditor('getHtml')

      if (innerHtml) {
        templateHTML = innerHtml
      } else {
        templateHTML = $wrapper.html()
      }

      templateHTML = templateHTML
        .replace(/class=""/g, '')
        .replace(/style=""/g, '')
        .replace(/class=''/g, '')
        .replace(/style=''/g, '')
        .replace('  ', ' ')

      templateHTML = prettyHtml(templateHTML, {
        indent_size: 2,
        space_in_empty_paren: true,
      })

      templateHTML = FWTools.fixVueComponentNames(templateHTML)

      this.templateCode = templateHTML

      return templateHTML
    },
    handleClick(e) {
      $('.templateWrapper *').removeAttr('editSelected')

      //add it just to this tag
      $(e.target)
        .attr('editSelected', true)
        .attr('contenteditable', true)
      var classArray = []
      classArray = e.target.classList.value.split(' ')
      this.editorElement = e.target
      this.editorClasses = e.target.classList.value !== '' ? classArray : null
      let colClass = null
      //console.log('col class on load is ', this.elColClass, 'class array is', classArray)
      for (const c of classArray) {
        if (c.toString().indexOf('col') > -1) colClass = c
      }
      this.elColClass = colClass ? colClass : ''

      //console.log('col class after set is ', this.elColClass)

      var textTags = ' H1 H2 H3 P BUTTON'
      if (textTags.includes(this.editorElement.tagName)) {
        this.elText = $(e.target).text()
      } else {
        this.elText = null
      }

      FWTools.onElSelected($(e.target), this.updateTemplate)

      this.refreshTemplateWrapperAutoSuggest()
    },
    cellColChange(checked) {
      //remove any col class from array
      console.log('col change class is', this.elColClass, checked)
      for (let i = 0; i < this.editorClasses.length; i++) {
        const c = this.editorClasses[i]
        if (c.indexOf('col-') > -1) this.editorClasses.splice(i, 1)
        //console.log('class removed')
      }
      this.editorClasses.push(checked)
      // console.log('col class set to', checked)
      //add selected one
    },
    textChange() {
      // set the text of the element to what was typed
      $(this.editorElement).text(this.elText.trim())
      this.updateTemplate()
    },
    removeElement(el) {
      // set the text of the element to what was typed
      $(this.editorElement).remove()
      this.updateTemplate()
    },
    copyElement(el) {
      // set the text of the element to what was typed
      this.elToCopy = $(this.editorElement).prop('outerHTML')
    },
    pasteElement() {
      // set the text of the element to what was typed
      if (this.editorElement) $(this.editorElement).append(this.elToCopy)
      this.updateTemplate()
    },
    addRow() {
      const newRow = `
        <div class="row">
          <div class="col-6">
          </div>
          <div class="col-6">
          </div>
        </div>`

      $('.templateWrapper').append(newRow)

      this.updateTemplate()
    },
    addElement(value, instanceId) {
      const comps = {
        row: `
          <div class="row">
            <div class="col-6">
            </div>
            <div class="col-6">
            </div>
          </div>`,
        col: `
          <div class="col-6">
          </div>`,
        h1: `<h1>text</h1>`,
        h2: `<h2>text</h2>`,
        h3: `<h3>text</h3>`,
        p: `<p>text</p>`,
        button: `<button class='btn btn-primary'>button name</button>`,
      }

      if (this.editorElement) $(this.editorElement).append(comps[value])
      this.updateTemplate()
      this.addTreeValue = 'Select'
    },
    initTemplateWrapperAutoSuggest() {
      const inputs = $('.templateWrapper').find('*[contenteditable="true"]')

      if (!inputs.length) return

      this.autoSuggestInstance = new AutoSuggest(
        {
          dropdownParentEl: $('.dashboard__wrapper').get(0),
          caseSensitive: false,
          maxSuggestions: 100,
          suggestions: [
            {
              trigger: '{',
              values: this.dataSourceOptions,
            },
            {
              trigger: '@',
              values: this.dataSourceOptions,
            },
          ],
        },
        ...inputs
      )
    },
    releaseTemplateWrapperAutoSuggest() {
      if (this.autoSuggestInstance) this.autoSuggestInstance.destroy()
      $('.dashboard__wrapper')
        .find('> .auto-suggest-dropdown')
        .remove()
    },
    refreshTemplateWrapperAutoSuggest() {
      this.releaseTemplateWrapperAutoSuggest()
      this.$nextTick(() => {
        this.initTemplateWrapperAutoSuggest()
      })
    },
    setInitialColumnCount(widget) {
      if (!widget.columnCount) widget.columnCount = 12
    },
    setInitialMinAndMaxWidth() {
      if (!widget.columnMinWidth) widget.columnMinWidth = 0
      if (!widget.columnMaxWidth) widget.columnMaxWidth = 100
    },
  },
  created() {
    eventBus.$on('elClick', this.handleClick)

    this.widgetKey = this.toolsPanel_openedItemsDescription.editWidget.key
    this.getWidget()

    this.unwatch = this.$watch('toolsPanel_openedItemsDescription', () => {
      this.widgetKey = this.toolsPanel_openedItemsDescription.editWidget.key
      this.getWidget()
    })

    var propsHolder = []
    var template = this.templateCode
    var list = template.split(':')
    var propObj = []

    list.forEach(function(entry, i) {
      if (i == 0) return
      var obj = { name: '', value: '', oldValue: '' }

      obj.name = entry.split('="')[0]
      obj.value = entry.split('"')[1]
      obj.oldValue = entry.split('"')[1]
      propObj.push(obj)
    })

    this.propsArray = propObj
  },
  mounted() {
    this.selectElement()

    eventBus.$on('gridEditorSaved', this.updateTemplate)

    if (!this.frontwiseLoaded) {
      $(document).ready(() => {
        $('.templateWrapper:not(.ge-editing)').gridEditor({
          new_row_layouts: [[12], [6, 6], [4, 4, 4]],
          content_types: ['summernote'],
          summernote: {
            config: {
              callbacks: {
                onInit: function() {
                  var element = this
                },
              },
            },
          },
        })

        this.frontwiseLoaded = true
      })
    }
  },
  beforeDestroy() {
    this.unwatch()

    eventBus.$off('elClick', this.handleClick)
    eventBus.$off('gridEditorSaved', this.updateTemplate)

    $('#geToolsPanelSingle').remove()
    $('.templateWrapper').gridEditor('remove')

    this.releaseTemplateWrapperAutoSuggest()
  },
}
</script>

<style lang="scss">
.widgetEditForm {
  .CodeMirror {
    border: 1px solid #ddd;
    height: 20vh;
  }
  .optionsMapTextArea .CodeMirror {
    height: 120px !important;
  }
}
.splitpanes__pane {
  -webkit-transition: unset !important;
  transition: unset !important;
  background-color: #f8f9fe;
}
.ge-canvas.ge-editing .column > .ge-tools-drawer {
  background: transparent;
}
.ge-canvas.ge-editing .ge-tools-drawer {
  background: transparent;
}

.column {
  padding: 5px !important;
  margin-top: 5px;
}

[editSelected] > .ge-tools-rows {
  display: block !important;
}

.ge-tools-rows {
  display: none !important;
  border-top-left-radius: 2px !important;
  border-bottom-left-radius: 2px;
  width: 14px !important;
  height: 60px !important;
  left: 2px !important;
  // outline: unset !important;
  background: #2fa4e7 !important;
  margin-top: -6px;
}
.ge-tools-rows > a {
  display: block !important;
  outline: unset !important;

  padding: 1px !important;
}

.ui-sortable.row {
  //border: 1px solid #5e72e4 !important;
  //padding: 0 2px 2px;
  padding: 5px;
  margin-left: 13px !important;
  margin-right: 0 !important;
  //outline: 0.3px dashed #dddddd;
  //outline: unset !important;
}

.ge-canvas.ge-editing .column {
  //border: 1.1px solid #2fa4e7;
  // border-bottom-right-radius:5px;
  // border-top-left-radius:5px;
  // border-top-right-radius:5px;
  //padding: 0 5px 5px;
}

[editSelected] > .ge-tools-cols {
  display: block !important;
}

[editSelected] > .tagLabel {
  display: block !important;
}

[mouseon] > .tagLabel {
  display: block;
}

.tagLabel {
  position: absolute;
  height: 17px;
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
  margin-top: -24px;
  background: #2fa4e7;
  /* top: 229px; */
  /* left: 17px; */
  font-size: 10px;
  color: white;
  display: none;
}

.ge-tools-cols {
  display: none !important;
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
  width: 86px !important;
  height: 15px !important;
  top: -15px;
  left: unset !important;
  right: -2px !important;
  outline: unset !important;
  position: absolute !important;
  background: #2fa4e7 !important;
}

.ge-tools-cols > a {
  display: table-cell !important;
  outline: unset !important;
  padding: 1px !important;
}

.svg-inline--fa.fa-w-16 {
  width: 0.7em;
  height: 0.7em !important;
  min-height: 0.5px !important;
  display: block;
  outline: unset !important;
  color: white;
}

.svg-inline--fa.fa-w-14 {
  width: 0.7em;
  height: 0.7em !important;
  min-height: 0.5px !important;
  display: block;
  outline: unset !important;
  color: white;
}

#fwBootstrapEditSideBar
  [iscollapsible='true']
  > .input-group
  > .input-group-prepend
  > .input-group-text {
  padding-left: 15px;
}
#fwBootstrapEditSideBar .input-group-prepend .input-group-text,
#fwBootstrapEditSideBar .input-group-append .input-group-text {
  color: #fff;
  border-color: #5e72e4;
  background-color: #5e72e4;
  text-align: right;
  flex-direction: row-reverse;
  font-size: 0.7em !important;
}
#fwBootstrapEditSideBar .input-group-append .input-group-text {
  width: 30px;
  text-align: left;
  flex-direction: row;
}

.fwtabHeading {
  cursor: pointer;
  background: #e8f2ff;
  color: #5e72e4;
}
.fwtabHeading:hover {
  background: #e4eefb;
  color: #3f45e4;
}
.fwtabHeading > .expand {
  position: absolute;
  margin-top: 8px;
  margin-left: 8px;
  z-index: 1;
  font-size: 12px;
  width: 10px;
  height: 10px;
  line-height: 11px;
  transition: transform 200ms;
  transform: rotateZ(90deg);
}
.fwtabHeading.collapsed > .expand {
  transform: rotateZ(0);
}
</style>
